(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        if(this.header.querySelector('details[open]')) {
          this.header.querySelector('sticky-header').classList.add('headerCustomColor')
        } else {
          this.header.querySelector('sticky-header').classList.remove('headerCustomColor')
        }
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sandro-accordions"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.body.addEventListener('click', function(event) {
        // const questions = document.querySelectorAll('.shopify_explorer_faq__question');
        // questions.forEach(function(question) {
        //   question.classList.remove('active');
        // });
      if (event.target.classList.contains('shopify_explorer_faq__question')) {
        let answer = event.target.nextElementSibling;
        answer.style.display = (answer.style.display === 'block' ? 'none' : 'block');
        answer.classList.toggle('active');
        event.target.classList.toggle('active');
      }
    });
  
    document.addEventListener('shopify:block:select', function(event) {
      if (event.target.closest('#shopify-section-page-shopify_explorer_faq-template')) {
        let answers = event.target.querySelectorAll('.shopify_explorer_faq__answer');
        answers.forEach(function(answer) {
          answer.style.display = 'block';
        });
      }
    });
  
    document.addEventListener('shopify:block:deselect', function(event) {
      if (event.target.closest('#shopify-section-page-shopify_explorer_faq-template')) {
        let answers = event.target.querySelectorAll('.shopify_explorer_faq__answer');
        answers.forEach(function(answer) {
          answer.style.display = 'none';
        });
      }
    });
  }());
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sandro-image-grid"] && !Shopify.designMode) return;
  try {
    
  /*
    <sandro-grid-video data-mode="ambient">: reproduce el video (muted/loop) solo mientras
    está en pantalla y lo pausa al salir. Con prefers-reduced-motion no se reproduce y
    queda la portada. Si el navegador bloquea el autoplay, también queda la portada.
    data-mode="player" no necesita JS: usa los controles nativos.
  */
  if (!customElements.get('sandro-grid-video')) {
    class SandroGridVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video || this.dataset.mode !== 'ambient') return;

        this.handlePlaying = () => this.classList.add('is-playing');
        this.video.addEventListener('playing', this.handlePlaying);

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.video.muted = true;

        if (!('IntersectionObserver' in window)) {
          this.play();
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.play();
              } else {
                this.video.pause();
              }
            });
          },
          { rootMargin: '200px 0px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
        if (this.video && this.handlePlaying) {
          this.video.removeEventListener('playing', this.handlePlaying);
        }
      }

      play() {
        const playPromise = this.video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      }
    }

    customElements.define('sandro-grid-video', SandroGridVideo);
  }

  } catch(e) { console.error(e); }
})();
})();
